export type BuilderItem = {
  description: string;
  qty: number;
  unit: string;
  price: number;
  tax: number;
};

export type BuilderState = {
  // Sender
  companyName: string;
  companyAddress: string;
  city: string;
  country: string;
  zipCode: string;
  taxId: string;
  email: string;
  bankName: string;
  accountNumber: string;
  bic: string;
  // Client
  clientName: string;
  clientAddress: string;
  clientZipCode: string;
  clientCity: string;
  clientCountry: string;
  clientTaxNumber: string;
  // Invoice meta
  invoiceNumber: string;
  invoiceType: string;
  serviceFrom: string;
  serviceTo: string;
  issuedDate: string;
  dueDate: string;
  currency: 'EUR' | 'USD' | 'RSD' | 'GBP';
  // Items
  items: BuilderItem[];
};

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

function futureDateISO(days: number) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export const DEFAULT_BUILDER_STATE: BuilderState = {
  companyName: '',
  companyAddress: '',
  zipCode: '',
  city: '',
  country: '',
  taxId: '',
  email: '',
  bankName: '',
  accountNumber: '',
  bic: '',
  clientName: '',
  clientAddress: '',
  clientZipCode: '',
  clientCity: '',
  clientCountry: '',
  clientTaxNumber: '',
  invoiceNumber: `${new Date().getFullYear()}-1`,
  invoiceType: 'Invoice',
  serviceFrom: todayISO(),
  serviceTo: '',
  issuedDate: todayISO(),
  dueDate: futureDateISO(30),
  currency: 'EUR',
  items: [{ description: '', qty: 1, unit: 'pcs', price: 0, tax: 0 }],
};

export const PLACEHOLDER_BUILDER_STATE: BuilderState = {
  companyName: 'Acme Corp Ltd.',
  companyAddress: '14 Business Park',
  zipCode: 'EC1A 1BB',
  city: 'London',
  country: 'United Kingdom',
  taxId: 'GB123456789',
  email: 'hello@acmecorp.com',
  bankName: 'Barclays Bank',
  accountNumber: 'GB29 NWBK 6016 1331 9268 19',
  bic: 'BARCGB22',
  clientName: 'Globe Media Inc.',
  clientAddress: '300 Park Avenue',
  clientZipCode: 'NY 10022',
  clientCity: 'New York',
  clientCountry: 'United States',
  clientTaxNumber: 'US98-7654321',
  invoiceNumber: `${new Date().getFullYear()}-1`,
  invoiceType: 'Invoice',
  serviceFrom: todayISO(),
  serviceTo: futureDateISO(30),
  issuedDate: todayISO(),
  dueDate: futureDateISO(30),
  currency: 'EUR',
  items: [
    {
      description: 'Web Design & Development',
      qty: 1,
      unit: 'project',
      price: 2500,
      tax: 20,
    },
    {
      description: 'Monthly Maintenance',
      qty: 3,
      unit: 'month',
      price: 300,
      tax: 20,
    },
  ],
};
